import { render, staticRenderFns } from "./CellRendererUpdated.vue?vue&type=template&id=2b022200&"
import script from "./CellRendererUpdated.vue?vue&type=script&lang=js&"
export * from "./CellRendererUpdated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports